import type { HTMLComponent } from "@commercekit/react";
import type { KlaviyoEmbedFormSliceTwoColumn } from "prismicio-types";
import { useMemo } from "react";
import { richTextResolver, linkResolver } from "~/lib/prismic/utils";

const KlaviyoEmbedFormTwoColumn: HTMLComponent<{
  slice: KlaviyoEmbedFormSliceTwoColumn;
  formId: string;
}> = ({ slice, formId }) => {
  const isFormLeft = slice.primary.position === "left";

  const leftContent = useMemo(
    () => richTextResolver(slice.primary.left_content, linkResolver),
    [slice.primary.left_content]
  );

  const rightContent = useMemo(
    () => richTextResolver(slice.primary.right_content, linkResolver),
    [slice.primary.right_content]
  );

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="klaviyo-embed-form klaviyo-embed-form--two-column">
      <div className="container">
        {slice.primary.heading && (
          <h2 className="heading strong xl underlined left pb-3 mb-3">
            {slice.primary.heading}
          </h2>
        )}
        <div className="row">
          <div className="col-12 col-md-6">
            <div
              className="content"
              dangerouslySetInnerHTML={{ __html: leftContent || "" }}
            />
            {isFormLeft && (
              <div
                key={formId}
                className={`klaviyo-form-${formId} klaviyo-embed-form__form`}
                suppressHydrationWarning
              />
            )}
          </div>
          <div className="col-12 col-md-6">
            <div
              className="content"
              dangerouslySetInnerHTML={{ __html: rightContent || "" }}
            />
            {!isFormLeft && (
              <div
                key={formId}
                className={`klaviyo-form-${formId} klaviyo-embed-form__form`}
                suppressHydrationWarning
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default KlaviyoEmbedFormTwoColumn;
